import { OnInit, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { State } from "@progress/kendo-data-query";
import { GridDataResult } from "@progress/kendo-angular-grid";

export abstract class DataGridComponent implements OnInit, OnDestroy {
  public loading = true;
  public view: Observable<GridDataResult>;
  protected pagingForward: boolean;
  protected pagingBack: boolean;
  unsubscribe$: Subject<any> = new Subject();

  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
  };

  ngOnInit(refresh: boolean = true) {
    if (refresh)
      this.refresh();
  }

  protected refreshObservable(observable: Observable<object>): void {
    observable.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.refresh();
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  protected abstract refresh();

  public onStateChange(state: State) {
    this.loading = true;
    this.pagingForward = state.skip > this.gridState.skip;
    this.pagingBack = state.skip < this.gridState.skip;
    this.gridState = state;
    this.refresh();
  }
}
